var C = Object.defineProperty, P = Object.defineProperties;
var j = Object.getOwnPropertyDescriptors;
var m = Object.getOwnPropertySymbols;
var g = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var T = (e, n, t) => n in e ? C(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, u = (e, n) => {
  for (var t in n || (n = {}))
    g.call(n, t) && T(e, t, n[t]);
  if (m)
    for (var t of m(n))
      h.call(n, t) && T(e, t, n[t]);
  return e;
}, p = (e, n) => P(e, j(n));
var b = (e, n) => {
  var t = {};
  for (var s in e)
    g.call(e, s) && n.indexOf(s) < 0 && (t[s] = e[s]);
  if (e != null && m)
    for (var s of m(e))
      n.indexOf(s) < 0 && h.call(e, s) && (t[s] = e[s]);
  return t;
};
import { useRef as w, useCallback as q, useEffect as K, cloneElement as U } from "react";
import { u as $ } from "./Transition-DN_8_tJg.js";
import { jsx as v } from "react/jsx-runtime";
import { r as G } from "./rem-CMQJ_ZTp.js";
import { g as M, u as Z, i as J } from "./OptionalPortal-Ctng3n6E.js";
import { b as Q } from "./get-size-rXzn3RsE.js";
import { f as W, e as A, g as x, B as F, h as X, s as Y } from "./factory--gUH4vxz.js";
import { p as z } from "./polymorphic-factory-B5K75Ixh.js";
function Ae({ opened: e, shouldReturnFocus: n = !0 }) {
  const t = w(null), s = () => {
    var r;
    t.current && "focus" in t.current && typeof t.current.focus == "function" && ((r = t.current) == null || r.focus({ preventScroll: !0 }));
  };
  return $(() => {
    let r = -1;
    const o = (a) => {
      a.key === "Tab" && window.clearTimeout(r);
    };
    return document.addEventListener("keydown", o), e ? t.current = document.activeElement : n && (r = window.setTimeout(s, 10)), () => {
      window.clearTimeout(r), document.removeEventListener("keydown", o);
    };
  }, [e, n]), s;
}
const ee = /input|select|textarea|button|object/, R = "a, input, select, textarea, button, object, [tabindex]";
function te(e) {
  return process.env.NODE_ENV === "test" ? !1 : e.style.display === "none";
}
function ne(e) {
  if (e.getAttribute("aria-hidden") || e.getAttribute("hidden") || e.getAttribute("type") === "hidden")
    return !1;
  let t = e;
  for (; t && !(t === document.body || t.nodeType === 11); ) {
    if (te(t))
      return !1;
    t = t.parentNode;
  }
  return !0;
}
function I(e) {
  let n = e.getAttribute("tabindex");
  return n === null && (n = void 0), parseInt(n, 10);
}
function y(e) {
  const n = e.nodeName.toLowerCase(), t = !Number.isNaN(I(e));
  return /* @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition */ (ee.test(n) && !e.disabled || e instanceof HTMLAnchorElement && e.href || t) && ne(e);
}
function S(e) {
  const n = I(e);
  return (Number.isNaN(n) || n >= 0) && y(e);
}
function re(e) {
  return Array.from(e.querySelectorAll(R)).filter(S);
}
function se(e, n) {
  const t = re(e);
  if (!t.length) {
    n.preventDefault();
    return;
  }
  const s = t[n.shiftKey ? 0 : t.length - 1], r = e.getRootNode();
  let o = s === r.activeElement || e === r.activeElement;
  const a = r.activeElement;
  if (a.tagName === "INPUT" && a.getAttribute("type") === "radio" && (o = t.filter(
    (i) => i.getAttribute("type") === "radio" && i.getAttribute("name") === a.getAttribute("name")
  ).includes(s)), !o)
    return;
  n.preventDefault();
  const c = t[n.shiftKey ? t.length - 1 : 0];
  c && c.focus();
}
function oe(e = !0) {
  const n = w(null), t = (r) => {
    let o = r.querySelector("[data-autofocus]");
    if (!o) {
      const a = Array.from(r.querySelectorAll(R));
      o = a.find(S) || a.find(y) || null, !o && y(r) && (o = r);
    }
    o ? o.focus({ preventScroll: !0 }) : process.env.NODE_ENV === "development" && console.warn(
      "[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node",
      r
    );
  }, s = q(
    (r) => {
      e && r !== null && n.current !== r && (r ? (setTimeout(() => {
        r.getRootNode() ? t(r) : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", r);
      }), n.current = r) : n.current = null);
    },
    [e]
  );
  return K(() => {
    if (!e)
      return;
    n.current && setTimeout(() => t(n.current));
    const r = (o) => {
      o.key === "Tab" && n.current && se(n.current, o);
    };
    return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
  }, [e]), s;
}
var D = { root: "m_515a97f8" };
const ae = {}, N = W((e, n) => {
  const t = A("VisuallyHidden", ae, e), d = t, { classNames: s, className: r, style: o, styles: a, unstyled: l, vars: c } = d, f = b(d, ["classNames", "className", "style", "styles", "unstyled", "vars"]), i = x({
    name: "VisuallyHidden",
    classes: D,
    props: t,
    className: r,
    style: o,
    classNames: s,
    styles: a,
    unstyled: l
  });
  return /* @__PURE__ */ v(F, u(u({ component: "span", ref: n }, i("root")), f));
});
N.classes = D;
N.displayName = "@mantine/core/VisuallyHidden";
var L = { root: "m_9814e45f" };
const ie = {
  zIndex: M("modal")
}, ue = X(
  (e, { gradient: n, color: t, backgroundOpacity: s, blur: r, radius: o, zIndex: a }) => ({
    root: {
      "--overlay-bg": n || (t !== void 0 || s !== void 0) && Y(t || "#000", s != null ? s : 0.6) || void 0,
      "--overlay-filter": r ? `blur(${G(r)})` : void 0,
      "--overlay-radius": o === void 0 ? void 0 : Q(o),
      "--overlay-z-index": a == null ? void 0 : a.toString()
    }
  })
), V = z((e, n) => {
  const t = A("Overlay", ie, e), E = t, {
    classNames: s,
    className: r,
    style: o,
    styles: a,
    unstyled: l,
    vars: c,
    fixed: f,
    center: i,
    children: d,
    radius: ce,
    zIndex: le,
    gradient: fe,
    blur: de,
    color: me,
    backgroundOpacity: pe,
    mod: O
  } = E, k = b(E, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "fixed",
    "center",
    "children",
    "radius",
    "zIndex",
    "gradient",
    "blur",
    "color",
    "backgroundOpacity",
    "mod"
  ]), B = x({
    name: "Overlay",
    props: t,
    classes: L,
    className: r,
    style: o,
    classNames: s,
    styles: a,
    unstyled: l,
    vars: c,
    varsResolver: ue
  });
  return /* @__PURE__ */ v(F, p(u(p(u({ ref: n }, B("root")), { mod: [{ center: i, fixed: f }, O] }), k), { children: d }));
});
V.classes = L;
V.displayName = "@mantine/core/Overlay";
function _({
  children: e,
  active: n = !0,
  refProp: t = "ref",
  innerRef: s
}) {
  const r = oe(n), o = Z(r, s);
  return J(e) ? U(e, { [t]: o }) : e;
}
function H(e) {
  return /* @__PURE__ */ v(N, u({ tabIndex: -1, "data-autofocus": !0 }, e));
}
_.displayName = "@mantine/core/FocusTrap";
H.displayName = "@mantine/core/FocusTrapInitialFocus";
_.InitialFocus = H;
export {
  _ as F,
  V as O,
  Ae as u
};
